// extracted by mini-css-extract-plugin
module.exports = {"root":"SortAdornment_root__MfzOy","icon":"SortAdornment_icon__1lhDL","up":"SortAdornment_up__2wzQN","down":"SortAdornment_down__1oal7","active":"SortAdornment_active__3hcxu"};